import React from 'react';
import { FiCheck, FiX } from 'react-icons/fi';
import BlockContainer from './BlockContainer';
import Button from '../Button';

function getFlexAlignment(alignment = '') {
  if (alignment === 'left') return 'flex-start';
  if (alignment === 'right') return 'flex-end';
  return 'center';
}

function getGridColumnsClass(columns = 1) {
  if (columns === 5) return 'grid-cols-table-mobile-5 md:grid-cols-table-5';
  if (columns === 4) return 'grid-cols-table-mobile-4 md:grid-cols-table-4';
  if (columns === 3) return 'grid-cols-table-mobile-3 md:grid-cols-table-3';
  if (columns === 2) return 'grid-cols-table-mobile-2 md:grid-cols-table-2';
  return 'grid-cols-table-mobile-1 md:grid-cols-table-1';
}

function RowText({ text = '' }) {
  if (text.includes('IconCheck')) return <FiCheck size={24} />;
  if (text.includes('IconCross')) return <FiX size={24} />;
  return text;
}

function Cell({ data, column, isColumn }) {
  const cellStyles = {
    textAlign: column.align || 'center',
    justifyContent: getFlexAlignment(column.align),
    backgroundColor: column.background || 'transparent',
    fontWeight: column.bold === 'true' ? '700' : '400',
  };

  return (
    <div
      className={`border-b-[1px] p-[0.9rem] text-[14px] leading-[17px] min-w-[106] md:min-w-[136px] w-full flex items-center !font-work ${
        isColumn
          ? 'rounded-t-2xl min-h-[64px] !font-medium md:text-[0.9rem] md:leading-[44px]'
          : 'min-h-[56px] md:leading-[20px] md:text-[0.8rem] md:leading-[20px]'
      }`}
      style={cellStyles}
    >
      {isColumn ? column.name : <RowText text={data} />}
    </div>
  );
}

export default function Table({
  title,
  description,
  table_heading,
  table = `{ "rows": [], "columns": [] }`,
  bgColor,
  textColor,
  padding,
  link,
}) {
  const jsonTable = JSON.parse(table);
  const columns = jsonTable.columns || [];
  const rows = jsonTable.rows || [];
  const hasData = columns.length > 0 && rows.length > 0;
  const hasColumnNames = columns.filter((column) => column.name).length > 0;
  const gridColumnsClass = getGridColumnsClass(columns.length);

  return (
    <BlockContainer
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      title={title}
      description={description}
    >
      {hasData ? (
        <div className="table-container mb-12 w-full max-w-3xl mx-auto">
          <div className="table-scroller overflow-x-auto w-[calc(100%+100px)] px-[50px] -ml-[50px]">
            <div className="table-block grid mb-2">
              {table_heading ? (
                <h3 className="text-left font-light">{table_heading}</h3>
              ) : null}
              <div
                className={`table-block__cells grid gap-x-2 ${gridColumnsClass}`}
              >
                {hasColumnNames
                  ? columns.map((column, columnIndex) => (
                      <Cell key={columnIndex} column={column} isColumn />
                    ))
                  : null}
                {rows.map((row, ri) =>
                  row.map((cell, cellIndex) => (
                    <div key={ri} className="table-block__row flex gap-2">
                      <Cell
                        key={cellIndex}
                        data={cell}
                        column={columns[cellIndex]}
                      />
                    </div>
                  )),
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}

      {link?.link_text && link?.link_url ? (
        <Button
          color={textColor === 'var(--text-light)' ? 'white' : 'midnight'}
          to={link.link_url}
          lg
        >
          {link.link_text}
        </Button>
      ) : null}
    </BlockContainer>
  );
}
